import { g as V } from "./getUrlWithLocale-Sb9sJa1R.mjs";
import { x as s } from "./_baseToString-CcsvGzgN.mjs";
import { g as _ } from "./_baseToString-CcsvGzgN.mjs";
import { parse as m, format as u } from "date-fns";
import { ko as f, zhCN as c, ja as y, it as g, uk as h, ru as x, fr as w, pt as P, de as T, es as D, enUS as $ } from "date-fns/locale";
import { draftMode as C } from "next/headers";
import { k as E } from "./kebabCase-DgoJgs5A.mjs";
import { C as p } from "./Content-NknxWl0R.mjs";
function H(e) {
  return typeof e == "number" ? new Date(e * 1e3) : typeof e == "string" ? m(e, "yyyy-MM-dd HH:mm:ss", /* @__PURE__ */ new Date()) : new Date(e);
}
const I = {
  en: $,
  es: D,
  de: T,
  pt: P,
  fr: w,
  ru: x,
  ua: h,
  it: g,
  ja: y,
  zh: c,
  ko: f
};
function v(e, r = "en", t = "PP") {
  const a = H(e), n = {
    locale: I[r]
  };
  return u(a, t, n);
}
const A = (e) => async (r) => {
  const { isEnabled: t } = await C();
  return t ? {
    ...r,
    "X-STAPE-PREVIEW": e
  } : r;
}, M = {
  "&nbsp;": " ",
  "&amp;": "&"
}, o = (e) => e.replace(/&nbsp;|&amp;/g, (r) => M[r] || r);
function d(e) {
  return e.replace(/<a\s+([^>]*href=")(?!#)([^"]*)("[^>]*)(>)/g, '<a $1$2$3 target="_blank"$4');
}
function L(e) {
  const r = /* @__PURE__ */ new Map();
  return e.map((t) => {
    switch (t.type) {
      case p.Type.header: {
        const a = E(t.data.text), n = r.get(a) || 0, i = n === 0 ? a : `${a}-${n}`;
        return r.set(a, n + 1), {
          ...t,
          data: {
            ...t.data,
            text: o(s(d(t.data.text))),
            elementId: i
          }
        };
      }
      case p.Type.table:
        return {
          ...t,
          data: {
            ...t.data,
            content: t.data.content.map((a) => a.map((n) => o(s(n))))
          }
        };
      case p.Type.paragraph:
        return {
          ...t,
          data: {
            ...t.data,
            text: o(s(d(t.data.text)))
          }
        };
      case p.Type.list:
        return {
          ...t,
          data: {
            ...t.data,
            items: t.data.items.map((a) => ({
              ...a,
              content: o(s(d(a.content)))
            }))
          }
        };
      case p.Type.code:
        return {
          ...t,
          data: {
            ...t.data,
            code: o(s(t.data.code))
          }
        };
      case p.Type.raw:
        return {
          ...t,
          data: {
            ...t.data,
            html: o(s(t.data.html))
          }
        };
      default:
        return t;
    }
  });
}
export {
  v as formatDate,
  _ as getUniquePageId,
  V as getUrlWithLocale,
  A as getWithPreviewHeader,
  H as parsePhpDate,
  L as sanitizeContentData
};
//# sourceMappingURL=utils.js.map
